import type { CapabilityObj } from 'homey-api';

import arrow_down from '../images/button/arrow_down.svg';
import arrow_up from '../images/button/arrow_up.svg';
import middle from '../images/button/middle.svg';
import windowcoverings_tilt_set_lower from '../images/slider/windowcoverings_tilt_set_lower.png';
import windowcoverings_tilt_set_upper from '../images/slider/windowcoverings_tilt_set_upper.png';

import { glyph } from '../../../theme/glyph';

export function getButtonImage(capabilityId: string, capabilityObj: CapabilityObj | undefined) {
  const [actualId] = capabilityId.split('.');

  const result: {
    url: string | null;
    useIconObj: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    iconObj: any;
    iconUrl: string | null;
  } = {
    url: null,
    useIconObj: false,
    iconObj: null,
    iconUrl: null,
  };

  switch (actualId) {
    case 'volume_mute':
      result.url = glyph.capability.volumeMuteCross;
      break;
    case 'volume_up':
      result.url = glyph.capability.volumeUp;
      break;
    case 'volume_down':
      result.url = glyph.capability.volumeDown;
      break;
    case 'windowcoverings_tilt_up':
      result.url = windowcoverings_tilt_set_upper;
      break;
    case 'windowcoverings_tilt_down':
      result.url = windowcoverings_tilt_set_lower;
      break;
    case 'channel_up':
      result.url = arrow_up;
      break;
    case 'channel_down':
      result.url = arrow_down;
      break;
    case 'speaker_shuffle':
      result.url = glyph.capability.speakerShuffle;
      break;
    case 'speaker_prev':
      result.url = glyph.capability.speakerPrev;
      break;
    case 'speaker_playing':
      result.url = glyph.core.play;
      break;
    case 'speaker_next':
      result.url = glyph.capability.speakerNext;
      break;
    case 'speaker_repeat':
      result.url = glyph.capability.speakerRepeat;
      break;
    default:
      if (capabilityObj != null && capabilityObj.iconObj != null) {
        result.url = `https://icons-cdn.athom.com/${capabilityObj.iconObj.id}.svg`;
        result.useIconObj = true;
        result.iconObj = capabilityObj.iconObj;
        break;
      }

      result.url = middle;
  }

  result.iconUrl = result.url;

  return result;
}
